import type { ComboboxItemGroup, InputBaseProps, InputWrapperProps } from '@mantine/core';
import { Input, InputBase } from '@mantine/core';

import classes from './input.module.css';

export * from '../Combobox/MultiSelect/MultiSelect';
export * from '../Combobox/Select/Select';
export * from './Checkbox/Checkbox';
export * from './ColorInput';
export * from './ColorPicker';
export * from './NumberInput/NumberInput';
export * from './NumberInput/useCurrencyHandler';
export * from './PasswordInput';
export * from './Pill/Pill';
export * from './PillsInput/PillsInput';
export * from './PinInput/PinInput';
export * from './Radio/Radio';
export * from './SearchInput/SearchInput';
export * from './SegmentedControl/SegmentedControl';
export * from './Slider';
export * from './Switch/Switch';
export * from './Textarea/TextArea';
export * from './TextInput';

// This can actually just be used to create the other defaults that fall under inputs!
const InputDefaultProps = {
  size: 'md',
};

const InputDefaults = Input.extend({
  defaultProps: InputDefaultProps,
  classNames: {
    wrapper: classes.wrapper,
    input: classes.input,
    section: classes.section,
  },
});

const InputWrapperDefaults = Input.Wrapper.extend({
  defaultProps: InputDefaultProps,
  classNames: {
    root: classes.root,
    label: classes.label,
    description: classes.description,
    error: classes.error,
    required: classes.required,
  },
});

export { Input, InputBase, InputDefaults, InputWrapperDefaults };
export type { ComboboxItemGroup, InputBaseProps, InputWrapperProps };
